module.exports = __webpack_public_path__ + "img/prepare-add-btn-disabled.e6806db7.svg";